module.exports = __webpack_public_path__ + "static/img/client-2.6112abb6.png";